import { Auth0Provider as BaseAuth0Provider } from '@auth0/auth0-react'
import type { ReactNode } from 'react'
import { auth0Config } from './config'

interface Props {
  children: ReactNode
}

export function Auth0Provider({ children }: Props) {
  return (
    <BaseAuth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={auth0Config.authorizationParams}
    >
      {children}
    </BaseAuth0Provider>
  )
}
